// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "img[data-v-29479153]{display:block;max-width:100%}@media screen and (max-width:1280px){h2[data-v-29479153]{display:none}}", ""]);
// Exports
module.exports = exports;
